export default "__VITE_ASSET__fXQKqQ1A__"